import React from 'react';
import { PublicOrganizer } from '@radevents/shared';

type SocialKey = 'stravaClubUrl' | 'instagramUrl' | 'facebookUrl' | 'komootUrl';

const SOCIALS: { key: SocialKey; label: string; background: string }[] = [
  { key: 'stravaClubUrl', label: 'Strava', background: '#fc5200' },
  { key: 'instagramUrl', label: 'Instagram', background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' },
  { key: 'facebookUrl', label: 'Facebook', background: '#1877f2' },
  { key: 'komootUrl', label: 'Komoot', background: '#6aa127' },
];

interface Props {
  organizer: Pick<PublicOrganizer, SocialKey>;
  style?: React.CSSProperties;
}

/** Brand-coloured chips for the organizer's social profiles. Renders nothing if none are set. */
const OrganizerSocialLinks: React.FC<Props> = ({ organizer, style }) => {
  const links = SOCIALS.filter(s => organizer[s.key]);
  if (links.length === 0) return null;

  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', ...style }}>
      {links.map(s => (
        <a
          key={s.key}
          href={organizer[s.key]}
          target="_blank"
          rel="noreferrer"
          style={{ fontSize: 13, padding: '6px 12px', borderRadius: 999, background: s.background, color: 'white', textDecoration: 'none', fontWeight: 600 }}
        >
          {s.label}
        </a>
      ))}
    </div>
  );
};

export default OrganizerSocialLinks;
